import { environment } from '@environment';
import moment from 'moment';
import { Observable, lastValueFrom } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { PromotionalDialogService } from '../promotional-dialog/promotional-dialog.service';

@Injectable({
  providedIn: 'root',
})
export class BuildInfoService {
  env = environment.envName;
  buildRelativeTime = '';
  buildBranch = '';
  commitSha = '';
  buildTime = '';
  newsList: any[] = [];
  buildCheckTime = 60000;
  buildTimeoutId: ReturnType<typeof setTimeout> | null = null;
  dialogs: any[] = [];

  http = inject(HttpClient);
  promotionalDialogService = inject(PromotionalDialogService);

  getBuildInfo(): Observable<Record<string, string>> {
    return this.http.get<Record<string, string>>('/assets/buildinfo.json');
  }

  async checkBuildInfo() {
    if (this.env !== 'local') {
      try {
        let buildinfo = await lastValueFrom(this.getBuildInfo());

        this.buildRelativeTime = moment.utc(buildinfo?.BUILD_TIME).fromNow();

        if (!this.buildBranch) {
          this.buildBranch = buildinfo?.BRANCH_NAME ?? '';
          this.buildTime = buildinfo?.BUILD_TIME ?? '';
          this.commitSha = buildinfo?.COMMIT_SHA ?? '';
        } else if (
          this.buildTime !== buildinfo?.BUILD_TIME &&
          !this.dialogs.find(dialog =>
            dialog.storageKey.startsWith(`new-version-banner-`)
          ) &&
          !localStorage.getItem(`new-version-banner-${this.buildTime}`)
        ) {
          const expirationDate = new Date(this.buildTime);
          expirationDate.setDate(expirationDate.getDate() + 7);

          const newVersionDialog = {
            title: 'New version available!',
            description: `A new version of Phoenix was released <strong> ${this.buildRelativeTime}</strong>. Refresh to get the latest version!`,
            storageKey: `new-version-banner-${this.buildTime}`,
            isVisible: false,
            severity: 'notification' as
              'info' | 'error' | 'success' | 'warning' | 'notification',
            expirationDate: expirationDate,
            isTemporary: false,
            hasDownloadButton: false,
          };
          this.promotionalDialogService.addDialog(newVersionDialog);
          this.dialogs.push(newVersionDialog);
        }
      } catch (error) {
        // Intentionally ignoring all errors here
        // this check happens in the background
      }

      if (!document.hidden) {
        // start check timer again
        this.startCheckTimer();
      }
    }
  }

  startCheckTimer() {
    this.buildTimeoutId = setTimeout(async () => {
      try {
        await this.checkBuildInfo();
      } catch (error) {
        throw new Error(`Fail on checking build info: ${error}`, {
          cause: error,
        });
      }
    }, this.buildCheckTime);
  }

  stopCheckTimer() {
    if (this.buildTimeoutId) {
      clearTimeout(this.buildTimeoutId);
      this.buildTimeoutId = null;
    }
  }
}
